export const environment = {
  production: true,
  buildId: '2100061067011791',
};
